import {Component, Input, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import {first, takeUntil} from 'rxjs/operators';

import { fuseAnimations } from '@fuse/animations';
import {EventDialogComponent} from "../../dialog/eventDialog.component";
import {FormGroup} from "@angular/forms";
import {ReservationDataService} from "../../../services/reservationData.service";
import {MatDialog} from "@angular/material/dialog";
import {User} from "../../day-view-scheduler.component";

@Component({
    selector     : 'calendar-main-sidebar',
    templateUrl  : './main-sidebar.component.html',
    styleUrls    : ['./main-sidebar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class CalendarMainSidebarComponent implements OnInit, OnDestroy
{
    folders: any[];
    filters: any[];
    tags: any[];
    accounts: object;
    selectedAccount: string;
    dialogRef: any;

    private _users: User[] = [];

    @Input()
    set users(users: User[]) {
        this._users = users;
    }

    get users(): User[] {
        return this._users;
    }

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     *
     * @param _matDialog
     * @param _router
     * @param reservationDataService
     */
    constructor(
        public _matDialog: MatDialog,
        private _router: Router,
        private reservationDataService: ReservationDataService,

    )
    {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {

    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    public addEvent() {
        this.dialogRef = this._matDialog.open(EventDialogComponent, {
            panelClass: 'contact-form-dialog',
            data      : {
                action : 'new',
                // categories: this.categories,
            }
        });
    }
}
